import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export const getpointsruleimage = option => {
  const urls = urlStringify(option)
  return request3('v1/vendorsetting/getpointsruleimage' + urls, {}, true, false) // 查询商家积分获取规则图片
}

export const getsettings = option => {
  return request3('v1/vendorsetting/getsettings', option, true, false) // 查询商家常用设置列表
}

export const getsetting = option => {
  const urls = urlStringify(option)
  return request3('v1/vendorsetting/getsetting' + urls, {}, true, false) // 查询商家常用设置
}

export const configsetting = option => {
  return request3('v1/vendorsetting/configsetting', option, true, false) // 配置商家常用设置
}

export const getinviterimage = option => {
  const urls = urlStringify(option)
  return request3('v1/vendorsetting/getinviterimage' + urls, {}, true, false) // 查询商家邀请好友页面图片
}

export const getwxappshareimage = option => {
  const urls = urlStringify(option)
  return request3('v1/vendorsetting/getwxappshareimage' + urls, {}, true, false) // 查询商家小程序分享页面图片
}

export default {
  // 查询商家常用设置
  getsetting: option => {
    const urls = urlStringify(option)
    return request3('v1/vendorsetting/getsetting' + urls, {}, true)
  },
  // 配置商家常用设置
  configsetting: option => {
    return request3('v1/vendorsetting/configsetting', option, true)
  },
  // 查询礼品卡配置
  getgiftcardconfig: option => {
    const urls = urlStringify(option)
    return request3('v1/gift/getgiftcardconfig' + urls, {}, true)
  },
  // 设置礼品卡
  configgiftcard: option => {
    return request3('v1/gift/configgiftcard', option, true)
  }
}
